import { IPrintBehavior, IPrintBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanHidable } from "../../../beans/objects";

export class PrintBehaviorTranslator {
  from(bean: IObjectBeanHidable): IPrintBehavior {
    return {
      shouldPrint: !bean["@hide"],
      shouldPreview: !bean["@hide"] || (bean["@hide"] === "2"),
    };
  }

  to(o: IPrintBehaviorSpecifiable) {
    return {
      hide: o.printBehavior.shouldPrint
        ? undefined
        : (o.printBehavior.shouldPreview ? "2" : "1"),
    };
  }
}
